package dev.danko.roblox_craft_ai.pages

import dev.danko.roblox_craft_ai.shared.model.ModelImportKind
import dev.danko.roblox_craft_ai.uikit.components.renderModelThumbnail
import dev.danko.roblox_craft_ai.uikit.components.previewImage
import dev.danko.roblox_craft_ai.uikit.components.ModelLibrary
import dev.danko.roblox_craft_ai.uikit.components.ModelLibraryDialog
import dev.danko.roblox_craft_ai.uikit.components.LibraryModel
import dev.danko.roblox_craft_ai.shared.model.displayTitle
import dev.danko.roblox_craft_ai.uikit.components.QualityPrefs
import dev.danko.roblox_craft_ai.uikit.components.TrianglePrefs
import dev.danko.roblox_craft_ai.uikit.components.TexturePrefs
import dev.danko.roblox_craft_ai.uikit.components.AnimationSetupPicker
import dev.danko.roblox_craft_ai.uikit.components.AnimationSetupPrefs
import dev.danko.roblox_craft_ai.uikit.components.QualityCredits
import dev.danko.roblox_craft_ai.uikit.components.MeshQualityChoices
import dev.danko.roblox_craft_ai.shared.model.GenerationQuality
import dev.danko.roblox_craft_ai.uikit.components.MeshToolsActions
import dev.danko.roblox_craft_ai.shared.model.MeshEditRequest
import org.jetbrains.compose.web.css.percent
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.em
import dev.danko.roblox_craft_ai.shared.model.PresetSeeds
import dev.danko.roblox_craft_ai.state.AuthState
import dev.danko.roblox_craft_ai.uikit.icons.Icon
import dev.danko.roblox_craft_ai.uikit.icons.AppIcon
import dev.danko.roblox_craft_ai.uikit.components.AssetDrawer
import dev.danko.roblox_craft_ai.uikit.components.AssetPanel
import dev.danko.roblox_craft_ai.uikit.components.WelcomeTour
import dev.danko.roblox_craft_ai.uikit.components.TileAction
import dev.danko.roblox_craft_ai.uikit.components.AssetTile
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.H2
import androidx.compose.runtime.key
import dev.danko.roblox_craft_ai.components.SiteSection
import dev.danko.roblox_craft_ai.components.StatusPill
import dev.danko.roblox_craft_ai.components.SiteHeader
import dev.danko.roblox_craft_ai.components.SiteFooter
import org.jetbrains.compose.web.css.FlexWrap
import dev.danko.roblox_craft_ai.uikit.components.AppAlert
import dev.danko.roblox_craft_ai.state.BackendStatus
import dev.danko.roblox_craft_ai.uikit.components.LanguageSwitcher
import dev.danko.roblox_craft_ai.uikit.i18n.FriendlyErrors
import dev.danko.roblox_craft_ai.uikit.i18n.LocaleController
import dev.danko.roblox_craft_ai.state.UiModeController
import dev.danko.roblox_craft_ai.state.Txt
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshots.SnapshotStateList
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.silk.components.icons.MoonIcon
import com.varabyte.kobweb.silk.components.icons.SunIcon
import com.varabyte.kobweb.silk.components.icons.fa.FaRobot
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.danko.roblox_craft_ai.client.RobloxCraftApiClient
import dev.danko.roblox_craft_ai.client.RobloxCraftWsClient
import dev.danko.roblox_craft_ai.components.FullscreenCodeDiffModal
import dev.danko.roblox_craft_ai.components.GenerationQueuePanel
import dev.danko.roblox_craft_ai.components.HealthStatusBadge
import dev.danko.roblox_craft_ai.components.SessionTokenModal
import dev.danko.roblox_craft_ai.components.SyncConfirmationModal
import dev.danko.roblox_craft_ai.components.UserSettingsModal
import dev.danko.roblox_craft_ai.components.ConceptApprovalCard
import dev.danko.roblox_craft_ai.components.isSkipSyncConfirmEnabled
import dev.danko.roblox_craft_ai.components.layouts.PageLayoutData
import dev.danko.roblox_craft_ai.components.loadSavedDefaultModelOrNull
import dev.danko.roblox_craft_ai.components.loadSavedDefaultType
import dev.danko.roblox_craft_ai.components.loadSavedSessionTokenOrNull
import dev.danko.roblox_craft_ai.components.saveSessionToken
import dev.danko.roblox_craft_ai.components.widgets.IconButton
import dev.danko.roblox_craft_ai.queue.GenerateQueueScheduler
import dev.danko.roblox_craft_ai.queue.QueuedAsset
import dev.danko.roblox_craft_ai.shared.model.AssetRequest
import dev.danko.roblox_craft_ai.shared.model.ConceptGenerationRequest
import dev.danko.roblox_craft_ai.shared.model.ConceptGenerationResult
import dev.danko.roblox_craft_ai.shared.model.ApproveConceptRequest
import dev.danko.roblox_craft_ai.shared.model.RerollConceptRequest
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Input
import dev.danko.roblox_craft_ai.shared.model.AssetResponse
import dev.danko.roblox_craft_ai.shared.model.AssetType
import dev.danko.roblox_craft_ai.shared.model.ChatMessage
import dev.danko.roblox_craft_ai.shared.model.GenerationStatus
import dev.danko.roblox_craft_ai.shared.model.PresetCategory
import dev.danko.roblox_craft_ai.shared.model.PresetDifficulty
import dev.danko.roblox_craft_ai.shared.model.PromptPresetDto
import dev.danko.roblox_craft_ai.shared.model.ProviderConfigDto
import dev.danko.roblox_craft_ai.shared.model.WsAssetUpdated
import dev.danko.roblox_craft_ai.shared.repository.IndexedDbAssetCacheRepository
import dev.danko.roblox_craft_ai.shared.repository.PersonalPresetRepositoryJs
import dev.danko.roblox_craft_ai.uikit.components.AlertVariant
import dev.danko.roblox_craft_ai.uikit.components.AppButton
import dev.danko.roblox_craft_ai.uikit.components.AppButtonSize
import dev.danko.roblox_craft_ai.uikit.components.AppButtonVariant
import dev.danko.roblox_craft_ai.uikit.components.AppCard
import dev.danko.roblox_craft_ai.uikit.components.AppInput
import dev.danko.roblox_craft_ai.uikit.components.AssetChatDrawer
import dev.danko.roblox_craft_ai.uikit.components.ReportAssetDialog
import dev.danko.roblox_craft_ai.uikit.components.ModalDialog
import dev.danko.roblox_craft_ai.uikit.components.ModalDialogConfirmActions
import dev.danko.roblox_craft_ai.uikit.components.PromptBox
import dev.danko.roblox_craft_ai.uikit.components.ToastContainer
import dev.danko.roblox_craft_ai.uikit.components.ToastManager
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import dev.danko.roblox_craft_ai.uikit.theme.toAppPalette
import kotlin.js.Date
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.await
import kotlinx.coroutines.currentCoroutineContext
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.isActive
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import kotlin.random.Random

private val AssetCache: IndexedDbAssetCacheRepository = IndexedDbAssetCacheRepository()
private var lastTokenHash12: String? = null

private val PersonalPresetsRepo: PersonalPresetRepositoryJs = PersonalPresetRepositoryJs()
private val SessionStorageJson = Json { ignoreUnknownKeys = true; encodeDefaults = true }

private suspend fun sha256Hash12(input: String): String {
    var h = 5381L
    for (c in input) {
        h = ((h shl 5) + h) + c.code.toLong()
    }
    val hex = h.toString(16).padStart(16, '0').filter { it.isLetterOrDigit() }
    val extra1 = (input.length * 2654435761L).toString(16).filter { it.isLetterOrDigit() }
    val combined = (hex + extra1).padEnd(12, '0')
    return combined.take(12)
}

val SessionTokenBadgeStyle = CssStyle.base {
    val palette = colorMode.toAppPalette()
    Modifier
        .padding(topBottom = 0.375.cssRem, leftRight = 0.75.cssRem)
        .borderRadius(9999.px)
        .backgroundColor(palette.surfaceElevated)
        .border(1.px, LineStyle.Solid, palette.border)
        .fontSize(0.8.cssRem)
        .fontFamily("ui-monospace", "SFMono-Regular", "Menlo", "monospace")
}

val MainContainerStyle = CssStyle {
    base { Modifier.fillMaxWidth().padding(leftRight = 1.cssRem, top = 1.cssRem, bottom = 12.cssRem).gap(1.5.cssRem) }
    Breakpoint.MD { Modifier.maxWidth(80.cssRem).padding(leftRight = 2.cssRem, top = 2.cssRem, bottom = 12.cssRem) }
}

val ConnectionDotStyle = CssStyle {
    base {
        val palette = colorMode.toAppPalette()
        Modifier
            .width(0.5.cssRem)
            .height(0.5.cssRem)
            .borderRadius(50.percent)
            .backgroundColor(palette.statusReady)
    }
}

private val PageScope = Any()

fun generateId(): String {
    val chars = "abcdef0123456789"
    return buildString {
        repeat(16) { append(chars[Random.nextInt(chars.length)]) }
    }
}

fun generateSessionToken(): String {
    val chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    return buildString {
        repeat(8) { append(chars[Random.nextInt(chars.length)]) }
    }
}

fun maskToken(raw: String): String {
    if (raw.length < 10) return raw
    val prefix = raw.take(6)
    val suffix = raw.takeLast(4)
    return "$prefix••••$suffix"
}

private fun copyToClipboard(text: String) {
    try {
        window.navigator.asDynamic().clipboard.writeText(text)
    } catch (_: Throwable) { }
}

private fun <T> SnapshotStateList<T>.updateFirst(
    predicate: (T) -> Boolean,
    transform: (T) -> T
) {
    val idx = indexOfFirst(predicate)
    if (idx >= 0) this[idx] = transform(this[idx])
}

val WorksGridStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .display(DisplayStyle.Grid)
        .gap(20.px)
        .styleModifier { property("grid-template-columns", "repeat(auto-fill, minmax(240px, 1fr))") }
}

/** A few varied curated ideas offered under the composer. */
private fun quickIdeas(): List<PromptPresetDto> {
    val ids = listOf("scr-damage-popup", "wpn-legendary-sword", "anim-idle-breathing", "scr-quest-dialog")
    return ids.mapNotNull { id -> PresetSeeds.ALL.firstOrNull { it.id == id } }
}

@InitRoute
fun initHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Txt.home.pageTitle))
}

@Composable
private fun AppHeader(
    sessionToken: String,
    connected: Boolean,
    activeProviders: List<ProviderConfigDto>,
    onOpenTokenModal: () -> Unit
) {
    val theme = LocalAppTheme.current
    val configuredAiCount = activeProviders.count { it.configured }
    val simpleMode = UiModeController.simpleMode

    SiteHeader(SiteSection.WORKSHOP) {
        if (!simpleMode) {
            StatusPill(
                label = if (configuredAiCount > 0) Txt.header.aiReady(configuredAiCount) else Txt.header.aiDemo,
                ok = configuredAiCount > 0,
                title = Txt.header.settings,
                onClick = { window.location.href = "/settings" }
            )
            HealthStatusBadge()
        }
        StatusPill(
            label = "Studio",
            ok = connected,
            title = if (connected) Txt.nav.studioConnected else Txt.nav.studioNotConnected,
            onClick = { onOpenTokenModal() }
        )
    }
}

@Page
@Composable
fun HomePage() {
    val theme = LocalAppTheme.current
    val scope = rememberCoroutineScope()
    val assets = remember { mutableStateListOf<AssetResponse>() }
    var isGenerating by remember { mutableStateOf(false) }
    var sessionToken by remember { mutableStateOf(loadSavedSessionTokenOrNull() ?: generateSessionToken()) }
    var showTokenModal by remember { mutableStateOf(false) }
    var showSettingsModal by remember { mutableStateOf(false) }
    var showSyncConfirm by remember { mutableStateOf(false) }
    var pendingSyncAsset by remember { mutableStateOf<AssetResponse?>(null) }
    var showFullscreenCode by remember { mutableStateOf(false) }
    var assetForFullscreen by remember { mutableStateOf<AssetResponse?>(null) }
    var connected by remember { mutableStateOf(false) }
    var activeProviders by remember { mutableStateOf<List<ProviderConfigDto>>(emptyList()) }
    var showChatDrawer by remember { mutableStateOf(false) }
    var reportTarget by remember { mutableStateOf<AssetResponse?>(null) }
    var reportSending by remember { mutableStateOf(false) }
    var chatAsset by remember { mutableStateOf<AssetResponse?>(null) }
    var chatMessages by remember { mutableStateOf<List<ChatMessage>>(emptyList()) }
    var isChatLoading by remember { mutableStateOf(false) }
    var currentGeneratingJobId by remember { mutableStateOf<String?>(null) }
    var activeGenerationJob by remember { mutableStateOf<kotlinx.coroutines.Job?>(null) }
    var prefillPrompt by remember { mutableStateOf<String?>(null) }
    var prefillType by remember { mutableStateOf<AssetType?>(null) }
    var prefillProviderId by remember { mutableStateOf<String?>(null) }
    var similarFlashTarget by remember { mutableStateOf(false) }
    var usePollingFallback by remember { mutableStateOf(false) }
    val wsConnected by RobloxCraftWsClient.isConnectedFlow.collectAsState()
    val wsFallback by RobloxCraftWsClient.fallbackPollingFlow.collectAsState()

    var currentPromptValue by remember { mutableStateOf("") }
    var currentTypeValue by remember { mutableStateOf<AssetType>(loadSavedDefaultType()) }
    var currentProviderValue by remember { mutableStateOf<String?>(null) }
    var interactiveConceptMode by remember { mutableStateOf(true) }
    var activeConcept by remember { mutableStateOf<ConceptGenerationResult?>(null) }
    var isApprovingConcept by remember { mutableStateOf(false) }
    var isRerollingConcept by remember { mutableStateOf(false) }
    var showSavePresetModal by remember { mutableStateOf(false) }
    var savePresetTitle by remember { mutableStateOf("") }
    var openedAssetId by remember { mutableStateOf<String?>(null) }
    var worksQuery by remember { mutableStateOf("") }
    var worksType by remember { mutableStateOf<AssetType?>(null) }
    var savePresetDesc by remember { mutableStateOf("") }
    var savePresetTagsRaw by remember { mutableStateOf("") }
    var savePresetLoading by remember { mutableStateOf(false) }
    var pendingPresetApplied by remember { mutableStateOf(false) }

    val wsConnected2 = wsConnected

    fun getEffectiveToken(): String {
        return sessionToken.takeIf { it.isNotBlank() }
            ?: loadSavedSessionTokenOrNull()?.takeIf { it.isNotBlank() }
            ?: "guest_session_default"
    }

    /** The model window, when open: true when it starts on the weapon. */
    var modelWindowWeapon by remember { mutableStateOf<Boolean?>(null) }

    fun cacheUpsert(a: AssetResponse) {
        val token = getEffectiveToken()
        scope.launch(Dispatchers.Default) {
            try {
                val hash = sha256Hash12(token)
                AssetCache.upsert(hash, a)
            } catch (_: Throwable) {}
        }
    }

    fun pollAndUpdate(id: String) {
        RobloxCraftApiClient.pollStatusFlow(id, 1200)
            .onEach { updated ->
                assets.updateFirst({ it.id == id }) {
                    cacheUpsert(updated)
                    updated
                }
            }
            .launchIn(scope)
    }

    fun updateAssetFromWsFrame(frame: WsAssetUpdated) {
        val fullAsset = frame.full_asset
        if (fullAsset != null) {
            assets.updateFirst({ it.id == frame.asset_id }) { fullAsset }
        } else {
            assets.updateFirst({ it.id == frame.asset_id }) { old ->
                old.copy(
                    status = frame.status,
                    payloadUrl = frame.model_url ?: old.payloadUrl,
                    errorMessage = frame.error_message ?: old.errorMessage,
                    metadata = old.metadata + frame.metadata
                )
            }
        }
        if (frame.status == GenerationStatus.READY || frame.status == GenerationStatus.FAILED) {
            RobloxCraftWsClient.unsubscribe(listOf(frame.asset_id))
        }
    }

    suspend fun runGenerateAsset(
        prompt: String,
        type: AssetType,
        providerId: String? = null,
        refImages: List<String> = emptyList(),
        refViews: List<String> = emptyList(),
        onProgress: ((Int) -> Unit)? = null
    ): Result<String> {
        val id = generateId()
        val meta = buildMap {
            if (!providerId.isNullOrBlank()) put("providerId", providerId)
            put("locale", LocaleController.current.code)
            // Better 3D models start from a picture: without an attached image the standard path runs.
            if (type == AssetType.MESH_3D && refImages.isNotEmpty()) put("meshQuality", QualityPrefs.mesh.name)
            if (type == AssetType.MESH_3D) put("targetPolycount", TrianglePrefs.target.toString())
            if (type == AssetType.MESH_3D) put("textureSize", TexturePrefs.size.toString())
            if (type == AssetType.MESH_3D && refViews.size == refImages.size && refViews.size > 1) put("referenceViews", refViews.joinToString(","))
            if (type == AssetType.ANIMATION) {
                // Models remembered by this browser that are no longer among the works are left out.
                val works = assets.filter { it.assetType == AssetType.MESH_3D && it.status == GenerationStatus.READY }
                val modelUrls = works.mapNotNull { it.payloadUrl }.toSet()
                val characterUrls = works.mapNotNull { work -> work.metadata["riggedModelUrl"]?.takeIf { work.metadata["riggedFor"] == work.payloadUrl } }.toSet()
                val setup = AnimationSetupPrefs.setup
                putAll(setup.copy(
                    characterUrl = setup.characterUrl?.takeIf { it in characterUrls },
                    weaponModelUrl = setup.weaponModelUrl?.takeIf { it in modelUrls },
                    offhandModelUrl = setup.offhandModelUrl?.takeIf { it in modelUrls }
                ).toMetadata())
            }
        }
        val request = AssetRequest(id = id, prompt = prompt, type = type, metadata = meta, referenceImages = refImages)
        val placeholder = AssetResponse(
            id = id,
            status = GenerationStatus.PROCESSING,
            assetType = type,
            prompt = prompt,
            referenceImages = refImages,
            metadata = mapOf("streamStatus" to "starting"),
            timestamp = Date.now().toLong()
        )
        assets.add(0, placeholder)
        cacheUpsert(placeholder)
        RobloxCraftWsClient.subscribe(listOf(placeholder.id))
        onProgress?.invoke(2)
        try {
            val initial = RobloxCraftApiClient.generate(request)
            assets.updateFirst({ it.id == id }) {
                cacheUpsert(initial)
                initial
            }
            onProgress?.invoke(8)

            if (type == AssetType.LUAU_SCRIPT) {
                var accumulated = ""
                var tokenCount = 0
                RobloxCraftApiClient.streamGeneration(
                    id = id,
                    onToken = { chunk, n ->
                        accumulated += chunk
                        tokenCount = n
                        val pct = (8 + ((tokenCount.toFloat() / 800f) * 82f)).toInt().coerceIn(8, 92)
                        onProgress?.invoke(pct)
                        assets.updateFirst({ it.id == id }) {
                            val u = it.copy(
                                status = GenerationStatus.PROCESSING,
                                luauCode = accumulated,
                                metadata = it.metadata + mapOf(
                                    "streamStatus" to "generating",
                                    "streamTokens" to n.toString()
                                )
                            )
                            cacheUpsert(u)
                            u
                        }
                    },
                    onStatus = { s ->
                        if (s.startsWith("retrying")) {
                            accumulated = ""
                        }
                        assets.updateFirst({ it.id == id }) {
                            val u = it.copy(
                                status = GenerationStatus.PROCESSING,
                                luauCode = if (s.startsWith("retrying")) "" else accumulated,
                                metadata = it.metadata + mapOf("streamStatus" to s)
                            )
                            cacheUpsert(u)
                            u
                        }
                    },
                    onDone = { _, _ ->
                        scope.launch {
                            delay(200)
                            onProgress?.invoke(98)
                            val finalResp = RobloxCraftApiClient.getStatus(id)
                            assets.updateFirst({ it.id == id }) {
                                cacheUpsert(finalResp)
                                finalResp
                            }
                            onProgress?.invoke(100)
                        }
                    }
                )
            } else {
                onProgress?.invoke(35)
                pollAndUpdate(id)
                scope.launch {
                    for (pct in 35..95 step 6) {
                        delay(700)
                        onProgress?.invoke(pct)
                        val st = assets.firstOrNull { it.id == id }?.status ?: continue
                        if (st == GenerationStatus.READY || st == GenerationStatus.FAILED) break
                    }
                    onProgress?.invoke(98)
                    val finalResp = RobloxCraftApiClient.getStatus(id)
                    assets.updateFirst({ it.id == id }) {
                        cacheUpsert(finalResp)
                        finalResp
                    }
                    onProgress?.invoke(100)
                }
            }
            delay(600)
            val final = assets.firstOrNull { it.id == id }
            return if (final?.status == GenerationStatus.READY) {
                Result.success(id)
            } else if (final?.status == GenerationStatus.FAILED) {
                Result.failure(Throwable(final.errorMessage ?: Txt.queue.generationFailed))
            } else {
                Result.success(id)
            }
        } catch (t: Throwable) {
            if (t is kotlinx.coroutines.CancellationException) {
                return Result.failure(t)
            }
            BackendStatus.requestRecheck()
            val friendly = FriendlyErrors.describe(t.message, Txt)
            ToastManager.error(Txt.home.generationFailed(friendly))
            assets.updateFirst({ it.id == id }) { old ->
                val failed = old.copy(
                    status = GenerationStatus.FAILED,
                    errorMessage = t.message ?: friendly
                )
                cacheUpsert(failed)
                failed
            }
            return Result.failure(t)
        }
    }

    LaunchedEffect(sessionToken) {
        if (sessionToken.length >= 8) {
            RobloxCraftWsClient.connect(sessionToken)
            RobloxCraftWsClient.assetUpdatesFlow
                .onEach { frame -> updateAssetFromWsFrame(frame) }
                .launchIn(this)
        }
    }

    LaunchedEffect(wsFallback) {
        usePollingFallback = wsFallback
        if (usePollingFallback) {
            val processingIds = assets.filter {
                it.status == GenerationStatus.PROCESSING || it.status == GenerationStatus.PENDING
            }.map { it.id }
            for (id in processingIds) {
                pollAndUpdate(id)
            }
        }
    }

    LaunchedEffect(BackendStatus.reachable) {
        if (BackendStatus.reachable == false) return@LaunchedEffect
        try {
            activeProviders = RobloxCraftApiClient.getProvidersSettings()
        } catch (_: Throwable) {
        }
    }

    LaunchedEffect(Unit) {
        try {
            val token = getEffectiveToken()
            val hash = sha256Hash12(token)
            lastTokenHash12 = hash
            val cached = AssetCache.getRecent(hash, 50)
            if (cached.isNotEmpty()) {
                val existingIds = assets.map { it.id }.toSet()
                cached.forEach { c ->
                    if (!existingIds.contains(c.id)) assets.add(c)
                }
                val sorted = assets.sortedByDescending { it.timestamp }
                assets.clear()
                assets.addAll(sorted)
                for (c in cached) {
                    if (c.status == GenerationStatus.PROCESSING || c.status == GenerationStatus.PENDING) {
                        pollAndUpdate(c.id)
                    }
                }
            } else if (assets.isEmpty()) {
                val sampleSword = AssetResponse(
                    id = "sample_wooden_sword_001",
                    prompt = Txt.home.samplePrompt,
                    assetType = AssetType.MESH_3D,
                    status = GenerationStatus.READY,
                    timestamp = Date.now().toLong(),
                    metadata = mapOf("polyCount" to "128", "format" to "procedural", "material" to "wood_oak", "demo" to "true")
                )
                assets.add(sampleSword)
                cacheUpsert(sampleSword)
            }

            try {
                val remoteAssets = RobloxCraftApiClient.getRecentAssets(50)
                if (remoteAssets.isNotEmpty()) {
                    for (remote in remoteAssets) {
                        assets.updateFirst({ it.id == remote.id }) { remote }
                        if (!assets.any { it.id == remote.id }) {
                            assets.add(remote)
                        }
                        cacheUpsert(remote)
                    }
                    val sorted = assets.sortedByDescending { it.timestamp }
                    assets.clear()
                    assets.addAll(sorted)
                }
            } catch (_: Throwable) {}

            launch(Dispatchers.Default) {
                try { AssetCache.purgeOld() } catch (_: Throwable) {}
            }
        } catch (_: Throwable) {}
    }

    LaunchedEffect(Unit) {
        while (isActive) {
            delay(10L * 60L * 1000L)
            try {
                val t = sessionToken.takeIf { it.isNotBlank() } ?: continue
                launch(Dispatchers.Default) {
                    try {
                        val h = sha256Hash12(t)
                        AssetCache.purgeOld()
                    } catch (_: Throwable) {}
                }
            } catch (_: Throwable) {}
        }
    }

    LaunchedEffect(sessionToken) {
        try {
            val newHash = if (sessionToken.isNotBlank()) sha256Hash12(sessionToken) else null
            val old = lastTokenHash12
            if (old != null && old != newHash) {
                launch(Dispatchers.Default) {
                    try { AssetCache.clearAll(old) } catch (_: Throwable) {}
                }
            }
            lastTokenHash12 = newHash
        } catch (_: Throwable) {}
        connected = false
        try {
            RobloxCraftApiClient.syncRoblox(sessionToken)
            connected = true
        } catch (_: Throwable) {
            connected = false
        }
    }

    LaunchedEffect(sessionToken, connected) {
        if (!connected) return@LaunchedEffect
        var hasPending = false
        while (isActive) {
            try {
                val statuses = RobloxCraftApiClient.getSyncStatus(sessionToken)
                hasPending = false
                for ((assetId, status) in statuses) {
                    if (status == "PENDING" || status == "DELIVERED") hasPending = true
                    assets.updateFirst({ it.id == assetId }) { old ->
                        val u = old.copy(
                            metadata = old.metadata + mapOf(
                                "uiSyncStatus" to status,
                                "uiSyncTimeMs" to Date.now().toString()
                            )
                        )
                        cacheUpsert(u)
                        u
                    }
                }
            } catch (_: Throwable) { }
            delay(if (hasPending) 5_000L else 20_000L)
        }
    }

    LaunchedEffect(Unit) {
        if (pendingPresetApplied) return@LaunchedEffect
        try {
            val raw = window.sessionStorage.getItem("robloxCraft.pendingPreset")
            if (!raw.isNullOrBlank()) {
                val preset = SessionStorageJson.decodeFromString(PromptPresetDto.serializer(), raw)
                prefillPrompt = preset.prompt
                currentPromptValue = preset.prompt
                val prefType = preset.preferredAssetType
                if (prefType != null) {
                    prefillType = prefType
                    currentTypeValue = prefType
                }
                similarFlashTarget = true
                pendingPresetApplied = true
                window.sessionStorage.removeItem("robloxCraft.pendingPreset")
                ToastManager.info(Txt.home.presetLoaded(preset.localizedTitle(LocaleController.current.code)))
            }
        } catch (_: Throwable) {
            pendingPresetApplied = true
        }
    }

    LaunchedEffect(Unit) {
        GenerateQueueScheduler.onStartItem = { asset: QueuedAsset ->
            val result = runCatching {
                runGenerateAsset(
                    prompt = asset.prompt,
                    type = asset.type,
                    providerId = asset.providerId,
                    refImages = emptyList(),
                    onProgress = { pct ->
                        GenerateQueueScheduler.updateProgress(asset.uuid, pct)
                    }
                )
            }
            result.getOrElse { t -> Result.failure(t) }
        }
    }

    fun handleGenerateSimilar(targetPrompt: String, targetType: AssetType, providerId: String?) {
        openedAssetId = null
        prefillPrompt = targetPrompt
        prefillType = targetType
        prefillProviderId = providerId
        currentPromptValue = targetPrompt
        currentTypeValue = targetType
        similarFlashTarget = true
        scope.launch {
            delay(50)
            window.asDynamic().requestAnimationFrame {
                val anchor = document.getElementById("prompt-box-anchor")
                if (anchor != null) {
                    anchor.asDynamic().scrollIntoView(js("{behavior: \"smooth\"}"))
                } else {
                    window.scrollTo(js("{ top: 0, behavior: \"smooth\" }"))
                }
            }
            delay(800)
            similarFlashTarget = false
        }
    }

    fun handleCancel(targetAsset: AssetResponse) {
        if (currentGeneratingJobId == targetAsset.id) {
            isGenerating = false
            activeGenerationJob?.cancel()
            currentGeneratingJobId = null
        }
        scope.launch {
            try {
                RobloxCraftApiClient.cancelGeneration(targetAsset.id)
            } catch (_: Throwable) {}
            assets.updateFirst({ it.id == targetAsset.id }) { old ->
                val u = old.copy(
                    status = GenerationStatus.FAILED,
                    errorMessage = Txt.home.cancelledByUser,
                    metadata = old.metadata + mapOf("cancelled" to "true")
                )
                cacheUpsert(u)
                u
            }
        }
    }

    /** Opens the AI chat for [targetAsset]; with [instruction] (from the panel's "What should change?") it is sent right away. */
    fun openChat(targetAsset: AssetResponse, instruction: String?) {
        chatAsset = targetAsset
        showChatDrawer = true
        scope.launch {
            chatMessages = try {
                RobloxCraftApiClient.getChatHistory(targetAsset.id)
            } catch (_: Throwable) {
                targetAsset.chatHistory
            }
            if (instruction != null) {
                isChatLoading = true
                try {
                    val resp = RobloxCraftApiClient.refactorAsset(assetId = targetAsset.id, instruction = instruction)
                    chatMessages = chatMessages + resp.chatMessage
                } catch (t: Throwable) {
                    ToastManager.error(Txt.home.refactorFailed(FriendlyErrors.describe(t.message, Txt)))
                } finally {
                    isChatLoading = false
                }
            }
        }
    }

    /** A finished 3D work as the model window shows it (the stored model, and its bones when it has them). */
    fun libraryModelOf(asset: AssetResponse) = LibraryModel(
        assetId = asset.id,
        title = asset.displayTitle,
        image = asset.previewImage(),
        glbUrl = asset.payloadUrl.orEmpty(),
        riggedUrl = asset.metadata["riggedModelUrl"]?.takeIf { asset.metadata["riggedFor"] == asset.payloadUrl },
        prompt = asset.prompt
    )

    fun putAsset(asset: AssetResponse) {
        cacheUpsert(asset)
        if (assets.none { it.id == asset.id }) assets.add(0, asset) else assets.updateFirst({ it.id == asset.id }) { asset }
    }

    /** The model window's data: the user's finished 3D works stored here, and what it can do with them. */
    fun modelLibrary() = ModelLibrary(
        models = assets.filter {
            it.assetType == AssetType.MESH_3D && it.status == GenerationStatus.READY &&
                it.payloadUrl?.startsWith("/api/v1/storage/") == true && it.metadata["demo"] != "true"
        }.map(::libraryModelOf),
        importFiles = { files, kind ->
            var asset = try {
                RobloxCraftApiClient.importModel(files, kind)
            } catch (t: Throwable) {
                throw IllegalStateException(FriendlyErrors.describe(t.message, Txt), t)
            }
            putAsset(asset)
            // A picture for its card, drawn here; a character gets the free template skeleton right away.
            asset.payloadUrl?.let { url -> renderModelThumbnail(url) }?.let { picture ->
                runCatching { RobloxCraftApiClient.setPreview(asset.id, picture) }.getOrNull()?.let { asset = it; putAsset(it) }
            }
            if (kind == ModelImportKind.CHARACTER) {
                runCatching { RobloxCraftApiClient.rigMesh(asset.id) }.getOrNull()?.let { asset = it; putAsset(it) }
            }
            libraryModelOf(asset)
        },
        addBones = { assetId ->
            val rigged = try {
                RobloxCraftApiClient.rigMesh(assetId)
            } catch (t: Throwable) {
                throw IllegalStateException(FriendlyErrors.describe(t.message, Txt), t)
            }
            putAsset(rigged)
            libraryModelOf(rigged)
        },
        openWork = { assetId -> openedAssetId = assetId }
    )

    val meshTools = remember {
        object : MeshToolsActions {
            override suspend fun info(assetId: String) = RobloxCraftApiClient.getMeshInfo(assetId)

            override suspend fun edit(assetId: String, request: MeshEditRequest): AssetResponse {
                val updated = try {
                    RobloxCraftApiClient.editMesh(assetId, request)
                } catch (t: Throwable) {
                    throw IllegalStateException(FriendlyErrors.describe(t.message, Txt), t)
                }
                assets.updateFirst({ it.id == updated.id }) {
                    cacheUpsert(updated)
                    updated
                }
                return updated
            }

            override suspend fun restore(assetId: String, revisionNumber: Int) {
                val result = RobloxCraftApiClient.rollbackRevision(assetId, revisionNumber)
                if (!result.success) error(result.message)
                val updated = RobloxCraftApiClient.getStatus(assetId)
                assets.updateFirst({ it.id == updated.id }) {
                    cacheUpsert(updated)
                    updated
                }
            }

            override fun objZipUrl(assetId: String) = RobloxCraftApiClient.meshObjZipUrl(assetId)
            override fun sharpGlbUrl(assetId: String) = RobloxCraftApiClient.meshSharpGlbUrl(assetId)

            override suspend fun retexture(assetId: String, request: dev.danko.roblox_craft_ai.shared.model.RetextureRequest): AssetResponse {
                val updated = try {
                    RobloxCraftApiClient.retextureMesh(assetId, request)
                } catch (t: Throwable) {
                    throw IllegalStateException(FriendlyErrors.describe(t.message, Txt), t)
                }
                assets.updateFirst({ it.id == updated.id }) {
                    cacheUpsert(updated)
                    updated
                }
                AuthState.refreshUsage()
                return updated
            }

            override suspend fun rig(assetId: String): AssetResponse {
                val updated = try {
                    RobloxCraftApiClient.rigMesh(assetId)
                } catch (t: Throwable) {
                    throw IllegalStateException(FriendlyErrors.describe(t.message, Txt), t)
                }
                assets.updateFirst({ it.id == updated.id }) {
                    cacheUpsert(updated)
                    updated
                }
                return updated
            }

            override suspend fun rigPro(assetId: String): AssetResponse {
                val updated = try {
                    RobloxCraftApiClient.rigMeshPro(assetId)
                } catch (t: Throwable) {
                    throw IllegalStateException(FriendlyErrors.describe(t.message, Txt), t)
                }
                assets.updateFirst({ it.id == updated.id }) {
                    cacheUpsert(updated)
                    updated
                }
                AuthState.refreshUsage()
                return updated
            }

            override suspend fun editAnimation(assetId: String, instruction: String): AssetResponse {
                val updated = try {
                    RobloxCraftApiClient.editAnimation(assetId, instruction)
                } catch (t: Throwable) {
                    throw IllegalStateException(FriendlyErrors.describe(t.message, Txt), t)
                }
                assets.updateFirst({ it.id == updated.id }) {
                    cacheUpsert(updated)
                    updated
                }
                AuthState.refreshUsage()
                return updated
            }

            override suspend fun restoreAnimation(assetId: String, revisionNumber: Int): AssetResponse {
                val updated = RobloxCraftApiClient.restoreAnimation(assetId, revisionNumber)
                assets.updateFirst({ it.id == updated.id }) {
                    cacheUpsert(updated)
                    updated
                }
                return updated
            }

            override fun animationEditCost() = AuthState.usage?.creditCosts?.get("ANIMATION")?.let { Txt.home.creditsCost(it) }

            override fun rigProCost() = AuthState.usage?.creditCosts?.get("MESH_RIG_PRO")?.let { Txt.home.creditsCost(it) }

            override fun retextureCost() = AuthState.usage?.creditCosts?.get("MESH_RETEXTURE")?.let { Txt.home.creditsCost(it) }
        }
    }

    fun restoreRevision(targetAsset: AssetResponse, number: Int) {
        scope.launch {
            try {
                val result = RobloxCraftApiClient.rollbackRevision(targetAsset.id, number)
                if (!result.success) error(result.message)
                val updated = RobloxCraftApiClient.getStatus(targetAsset.id)
                assets.updateFirst({ it.id == updated.id }) {
                    cacheUpsert(updated)
                    updated
                }
                ToastManager.success(Txt.revisions.restored(number))
            } catch (t: Throwable) {
                ToastManager.error(FriendlyErrors.describe(t.message, Txt))
            }
        }
    }

    fun handleSync(targetAsset: AssetResponse) {
        if (isSkipSyncConfirmEnabled()) {
            scope.launch {
                try {
                    assets.updateFirst({ it.id == targetAsset.id }) { old ->
                        val u = old.copy(
                            metadata = old.metadata + mapOf(
                                "uiSyncStatus" to "PENDING",
                                "uiSyncTimeMs" to Date.now().toString()
                            )
                        )
                        cacheUpsert(u)
                        u
                    }
                    RobloxCraftApiClient.markAssetForSync(sessionToken, targetAsset.id)
                    RobloxCraftApiClient.syncRoblox(sessionToken)
                } catch (_: Throwable) { }
            }
        } else {
            pendingSyncAsset = targetAsset
            showSyncConfirm = true
        }
    }

    fun handleDelete(targetAsset: AssetResponse) {
        if (openedAssetId == targetAsset.id) openedAssetId = null
        scope.launch {
            assets.removeAll { it.id == targetAsset.id }
            try {
                val token = getEffectiveToken()
                val hash = sha256Hash12(token)
                AssetCache.delete(hash, targetAsset.id)
            } catch (_: Throwable) {}
            try {
                RobloxCraftApiClient.deleteAsset(targetAsset.id)
            } catch (_: Throwable) {}
            ToastManager.info(Txt.home.cardDeleted(targetAsset.id.take(8)))
        }
    }

    fun handleRegenerate(targetAsset: AssetResponse) {
        scope.launch {
            ToastManager.info(Txt.home.regenerating)
            runGenerateAsset(
                prompt = targetAsset.prompt,
                type = targetAsset.assetType,
                providerId = targetAsset.metadata["providerId"],
                refImages = targetAsset.referenceImages
            )
        }
    }

    fun enqueueCurrentPrompt() {
        val effectivePrompt = currentPromptValue.trim()
        if (effectivePrompt.isBlank()) {
            ToastManager.warning(Txt.promptBox.emptyPrompt)
            return
        }
        val added = GenerateQueueScheduler.enqueue(
            prompt = effectivePrompt,
            type = currentTypeValue,
            providerId = currentProviderValue
        )
        ToastManager.success(Txt.home.queued(GenerateQueueScheduler.countPendingOrActive(), added.position))
    }

    fun openSavePresetModal() {
        if (currentPromptValue.isBlank()) {
            ToastManager.warning(Txt.home.enterPromptBeforeSaving)
            return
        }
        savePresetTitle = ""
        savePresetDesc = ""
        savePresetTagsRaw = ""
        showSavePresetModal = true
    }

    suspend fun submitSavePreset() {
        val title = savePresetTitle.trim()
        if (title.length < 3 || title.length > 60) return
        savePresetLoading = true
        try {
            val tags = savePresetTagsRaw.split(",", ";", " ")
                .map { it.trim().trimStart('#') }
                .filter { it.isNotBlank() }
                .take(6)
            val now = Date.now().toLong()
            val preset = PromptPresetDto(
                id = "personal-${now}-${Random.nextInt(100000)}",
                category = PresetCategory.PERSONAL,
                title = title,
                prompt = currentPromptValue,
                description = savePresetDesc.trim().takeIf { it.isNotBlank() } ?: Txt.home.personalPresetDescription,
                tags = tags,
                difficulty = PresetDifficulty.MEDIUM,
                author = Txt.common.you,
                isPublic = false,
                createdAtUtc = now,
                preferredAssetType = currentTypeValue
            )
            val result = PersonalPresetsRepo.add(preset)
            if (result.isSuccess) {
                ToastManager.success(Txt.home.presetSaved(title))
                showSavePresetModal = false
            } else {
                val msg = result.exceptionOrNull()?.message ?: Txt.home.presetSaveFailed
                ToastManager.error("⚠️ $msg")
            }
        } finally {
            savePresetLoading = false
        }
    }

    Column(
        Modifier.fillMaxWidth().minHeight(100.vh).backgroundColor(theme.colors.background),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        AppHeader(
            sessionToken = sessionToken,
            connected = connected,
            activeProviders = activeProviders,
            onOpenTokenModal = { showTokenModal = true }
        )
        Column(
            MainContainerStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            BackendStatus.Monitor()
            if (BackendStatus.reachable == false) {
                AppAlert(
                    title = "🔌 ${Txt.errors.backendDownTitle}",
                    message = Txt.errors.backendDownHint,
                    variant = AlertVariant.DANGER,
                    modifier = Modifier.fillMaxWidth().maxWidth(50.cssRem),
                    action = {
                        AppButton(
                            text = Txt.errors.checkAgain,
                            variant = AppButtonVariant.OUTLINE,
                            size = AppButtonSize.SM,
                            onClick = { BackendStatus.requestRecheck() }
                        )
                    }
                )
            }

            Column(
                Modifier.fillMaxWidth().gap(theme.spacing.xl),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Column(
                    Modifier
                        .fillMaxWidth()
                        .maxWidth(50.cssRem)
                        .gap(theme.spacing.md),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Column(
                        Modifier
                            .fillMaxWidth()
                            .gap(theme.spacing.xs),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Div(
                            Modifier
                                .fontSize(40.px)
                                .fontWeight(FontWeight.ExtraBold)
                                .textAlign(com.varabyte.kobweb.compose.css.TextAlign.Center)
                                .color(theme.colors.textPrimary)
                                .lineHeight(1.15)
                                .letterSpacing((-0.02).em)
                                .toAttrs()
                        ) {
                            SpanText(Txt.home.heroTitle)
                        }
                        Div(
                            Modifier
                                .fontSize(16.px)
                                .textAlign(com.varabyte.kobweb.compose.css.TextAlign.Center)
                                .color(theme.colors.textSecondary)
                                .maxWidth(40.cssRem)
                                .toAttrs()
                        ) {
                            SpanText(Txt.home.heroSubtitle)
                        }
                    }

                    PromptBox(
                        Modifier.fillMaxWidth(),
                        isGenerating,
                        loadSavedDefaultType(),
                        loadSavedDefaultModelOrNull(),
                        {
                            val targetId = currentGeneratingJobId
                            isGenerating = false
                            activeGenerationJob?.cancel()
                            currentGeneratingJobId = null
                            if (targetId != null) {
                                scope.launch {
                                    try {
                                        RobloxCraftApiClient.cancelGeneration(targetId)
                                    } catch (_: Throwable) {}
                                    assets.updateFirst({ it.id == targetId }) { old ->
                                        val u = old.copy(
                                            status = GenerationStatus.FAILED,
                                            errorMessage = Txt.home.cancelledByUser,
                                            metadata = old.metadata + mapOf("cancelled" to "true")
                                        )
                                        cacheUpsert(u)
                                        u
                                    }
                                }
                            }
                        },
                        prefillPrompt = prefillPrompt,
                        prefillType = prefillType,
                        prefillProviderId = prefillProviderId,
                        flashTrigger = similarFlashTarget,
                        showModelPicker = !UiModeController.simpleMode,
                        extraOptions = {
                            Row(Modifier.gap(8.px).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
                                AppButton(
                                    text = Txt.home.savePreset.removePrefix("💾 "),
                                    variant = AppButtonVariant.OUTLINE,
                                    size = AppButtonSize.SM,
                                    onClick = { openSavePresetModal() }
                                )
                                AppButton(
                                    text = Txt.home.addToQueue.removePrefix("✚ "),
                                    icon = AppIcon.PLUS,
                                    variant = AppButtonVariant.OUTLINE,
                                    size = AppButtonSize.SM,
                                    onClick = { enqueueCurrentPrompt() }
                                )
                            }
                            Label(attrs = Modifier.display(DisplayStyle.Flex).alignItems(AlignItems.Center).gap(8.px).cursor(Cursor.Pointer)
                                .fontSize(14.px).color(theme.colors.textPrimary).toAttrs()) {
                                Input(type = InputType.Checkbox) {
                                    checked(interactiveConceptMode)
                                    onChange { interactiveConceptMode = !interactiveConceptMode }
                                }
                                SpanText(Txt.home.conceptMode.trim().removePrefix("🎨 "))
                            }
                            SpanText(Txt.home.shiftHint.removePrefix("💡 "), Modifier.fontSize(13.px).color(theme.colors.textSecondary))
                        },
                        costFor = { type ->
                            val costs = AuthState.usage?.creditCosts
                            if (type == AssetType.MESH_3D && costs != null) {
                                // Sketch (when drawn first) plus the 3D model at the chosen quality levels.
                                val sketch = if (interactiveConceptMode) QualityCredits.sketchTotal(costs, QualityPrefs.sketch, QualityPrefs.variants) ?: 0 else 0
                                costs[QualityCredits.meshKind(QualityPrefs.mesh)]?.let { Txt.home.creditsCost(sketch + it) }
                            } else {
                                costs?.get(type.name)?.let { Txt.home.creditsCost(it) }
                            }
                        },
                        typeOptions = { type ->
                            if (type == AssetType.ANIMATION) AnimationSetupPicker(library = modelLibrary(), onOpenLibrary = { modelWindowWeapon = it })
                            if (type == AssetType.MESH_3D) {
                                MeshQualityChoices(
                                    costOf = { kind -> AuthState.usage?.creditCosts?.get(kind)?.let { Txt.home.creditsCost(it) } },
                                    showSketch = interactiveConceptMode
                                )
                            }
                        },
                        splitSheet = { image -> RobloxCraftApiClient.splitViews(image) }
                    ) { prompt, type, providerId, refImages, refViews ->
                        currentPromptValue = prompt
                        currentTypeValue = type
                        currentProviderValue = providerId
                        val evt: dynamic = window.asDynamic().event
                        val isShift = (evt != null && evt.shiftKey == true) == true
                        if (isShift) {
                            enqueueCurrentPrompt()
                        } else if (type == AssetType.MESH_3D && interactiveConceptMode && refViews.size < 2) {
                            // Several views of the object already show it: the model is built from them, no sketch.
                            isGenerating = true
                            activeGenerationJob = scope.launch {
                                try {
                                    ToastManager.info(Txt.home.conceptGenerating)
                                    val conceptResult = RobloxCraftApiClient.generateConcept(
                                        ConceptGenerationRequest(
                                            prompt = prompt,
                                            referenceImageUrls = refImages,
                                            interactiveApproval = true,
                                            quality = QualityPrefs.sketch,
                                            variants = QualityPrefs.variants
                                        )
                                    )
                                    if (QualityPrefs.sketch != GenerationQuality.STANDARD && conceptResult.quality == GenerationQuality.STANDARD) {
                                        ToastManager.warning(Txt.quality.drewCheaper)
                                    }
                                    activeConcept = conceptResult
                                    ToastManager.success(Txt.home.conceptReady)
                                } catch (t: Throwable) {
                                    ToastManager.error(Txt.home.conceptFailed(FriendlyErrors.describe(t.message, Txt)))
                                    val id = generateId()
                                    currentGeneratingJobId = id
                                    runGenerateAsset(
                                        prompt = prompt,
                                        type = type,
                                        providerId = providerId,
                                        refImages = refImages
                                    )
                                } finally {
                                    isGenerating = false
                                }
                            }
                        } else {
                            val id = generateId()
                            currentGeneratingJobId = id
                            isGenerating = true
                            activeGenerationJob = scope.launch {
                                try {
                                    runGenerateAsset(
                                        prompt = prompt,
                                        type = type,
                                        providerId = providerId,
                                        refImages = refImages,
                                        refViews = refViews
                                    )
                                } finally {
                                    isGenerating = false
                                    if (currentGeneratingJobId == id) {
                                        currentGeneratingJobId = null
                                    }
                                }
                            }
                        }
                    }

                    activeConcept?.let { concept ->
                        ConceptApprovalCard(
                            concept = concept,
                            isApproving = isApprovingConcept,
                            isRerolling = isRerollingConcept,
                            onApprove = { c ->
                                scope.launch {
                                    isApprovingConcept = true
                                    try {
                                        ToastManager.info(Txt.home.conceptApproved)
                                        val initialAsset = RobloxCraftApiClient.approveConcept(
                                            ApproveConceptRequest(
                                                conceptId = c.conceptId,
                                                approvedImageUrl = c.imageUrl,
                                                targetPolycount = TrianglePrefs.target,
                                                textureSize = TexturePrefs.size,
                                                preferred3dProvider = currentProviderValue,
                                                quality = QualityPrefs.mesh
                                            )
                                        )
                                        assets.add(0, initialAsset)
                                        cacheUpsert(initialAsset)
                                        RobloxCraftWsClient.subscribe(listOf(initialAsset.id))
                                        activeConcept = null
                                        pollAndUpdate(initialAsset.id)
                                        scope.launch {
                                            for (i in 1..40) {
                                                delay(1200)
                                                try {
                                                    val current = RobloxCraftApiClient.getStatus(initialAsset.id)
                                                    assets.updateFirst({ it.id == initialAsset.id }) {
                                                        cacheUpsert(current)
                                                        current
                                                    }
                                                    if (current.status == GenerationStatus.READY || current.status == GenerationStatus.FAILED) {
                                                        break
                                                    }
                                                } catch (_: Throwable) {}
                                            }
                                        }
                                    } catch (t: Throwable) {
                                        ToastManager.error(Txt.home.meshFromConceptFailed(FriendlyErrors.describe(t.message, Txt)))
                                    } finally {
                                        isApprovingConcept = false
                                    }
                                }
                            },
                            onReroll = { c ->
                                scope.launch {
                                    isRerollingConcept = true
                                    try {
                                        ToastManager.info(Txt.home.conceptRerolling)
                                        val updatedConcept = RobloxCraftApiClient.rerollConcept(
                                            RerollConceptRequest(conceptId = c.conceptId, quality = QualityPrefs.sketch, variants = QualityPrefs.variants)
                                        )
                                        if (QualityPrefs.sketch != GenerationQuality.STANDARD && updatedConcept.quality == GenerationQuality.STANDARD) {
                                            ToastManager.warning(Txt.quality.drewCheaper)
                                        }
                                        activeConcept = updatedConcept
                                        ToastManager.success(Txt.home.conceptRerolled)
                                    } catch (t: Throwable) {
                                        ToastManager.error(Txt.home.conceptRerollFailed(FriendlyErrors.describe(t.message, Txt)))
                                    } finally {
                                        isRerollingConcept = false
                                    }
                                }
                            },
                            onDismiss = {
                                activeConcept = null
                            },
                            modifier = Modifier.fillMaxWidth().margin(bottom = 0.5.cssRem),
                            costOf = { kind -> AuthState.usage?.creditCosts?.get(kind)?.let { Txt.home.creditsCost(it) } }
                        )
                    }

                    Row(
                        Modifier.fillMaxWidth().gap(8.px).flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        quickIdeas().forEach { preset ->
                            AppButton(
                                text = preset.localizedTitle(LocaleController.current.code),
                                variant = AppButtonVariant.OUTLINE,
                                size = AppButtonSize.SM,
                                modifier = Modifier.borderRadius(999.px).fontWeight(FontWeight.Medium),
                                onClick = {
                                    prefillPrompt = preset.prompt
                                    prefillType = preset.preferredAssetType
                                    currentPromptValue = preset.prompt
                                    preset.preferredAssetType?.let { currentTypeValue = it }
                                    ToastManager.info(Txt.home.presetLoaded(preset.localizedTitle(LocaleController.current.code)))
                                }
                            )
                        }
                        AppButton(
                            text = Txt.home.allIdeas,
                            variant = AppButtonVariant.GHOST,
                            size = AppButtonSize.SM,
                            modifier = Modifier.color(theme.colors.accentText),
                            onClick = { window.location.href = "/prompts" }
                        )
                    }
                }

                Column(
                    Modifier.fillMaxWidth().gap(20.px),
                    horizontalAlignment = Alignment.Start
                ) {
                    Row(Modifier.fillMaxWidth().gap(12.px).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
                        H2(Modifier.margin(0.px).fontSize(22.px).fontWeight(FontWeight.Bold).color(theme.colors.textPrimary).toAttrs()) {
                            Text(Txt.home.recentAssets)
                        }
                        SpanText("${assets.size}", Modifier.fontSize(14.px).color(theme.colors.textSecondary))
                        Spacer()
                        if (assets.isNotEmpty()) {
                            Box(Modifier.width(260.px).maxWidth(100.percent)) {
                                AppInput(
                                    value = worksQuery,
                                    onValueChanged = { worksQuery = it },
                                    placeholder = Txt.home.searchWorks,
                                    modifier = Modifier.fillMaxWidth()
                                )
                            }
                        }
                    }
                    if (assets.isNotEmpty()) {
                        Row(Modifier.gap(6.px).flexWrap(FlexWrap.Wrap)) {
                            (listOf<AssetType?>(null) + AssetType.entries).forEach { type ->
                                AppButton(
                                    text = type?.let { Txt.assetTypes.name(it) } ?: Txt.presetsPage.categoryAll,
                                    variant = if (worksType == type) AppButtonVariant.PRIMARY else AppButtonVariant.OUTLINE,
                                    size = AppButtonSize.SM,
                                    modifier = Modifier.borderRadius(999.px),
                                    onClick = { worksType = type }
                                )
                            }
                        }
                    }

                    val query = worksQuery.trim().lowercase()
                    val visibleAssets = assets.filter { asset ->
                        (worksType == null || asset.assetType == worksType) &&
                            (query.isEmpty() || asset.prompt.lowercase().contains(query) || asset.displayTitle.lowercase().contains(query))
                    }
                    if (assets.isEmpty()) {
                        Column(
                            Modifier
                                .fillMaxWidth()
                                .padding(48.px)
                                .borderRadius(16.px)
                                .border(1.px, LineStyle.Dashed, theme.colors.borderStrong)
                                .backgroundColor(theme.colors.surface)
                                .gap(10.px),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            Box(Modifier.color(theme.colors.accentText)) { Icon(AppIcon.SPARKLES, size = 32) }
                            SpanText(Txt.home.noAssetsTitle, Modifier.fontSize(17.px).fontWeight(FontWeight.Bold).color(theme.colors.textPrimary))
                            SpanText(Txt.home.noAssetsHint, Modifier.fontSize(14.px).color(theme.colors.textSecondary).textAlign(com.varabyte.kobweb.compose.css.TextAlign.Center))
                        }
                    } else if (visibleAssets.isEmpty()) {
                        SpanText(Txt.home.noMatches, Modifier.fontSize(14.px).color(theme.colors.textSecondary))
                    } else {
                        Div(WorksGridStyle.toModifier().toAttrs()) {
                            visibleAssets.forEach { asset ->
                                key(asset.id) {
                                    AssetTile(
                                        asset = asset,
                                        onOpen = { openedAssetId = asset.id },
                                        onSendToStudio = { handleSync(asset) },
                                        moreActions = buildList {
                                            add(TileAction(Txt.common.regenerate, AppIcon.ROTATE) { handleRegenerate(asset) })
                                            add(TileAction(Txt.home.generateSimilar, AppIcon.SPARKLES) { handleGenerateSimilar(asset.prompt, asset.assetType, asset.metadata["providerId"]) })
                                            if (asset.status == GenerationStatus.READY) add(TileAction(Txt.report.button, AppIcon.FLAG) { reportTarget = asset })
                                            add(TileAction(Txt.common.delete, AppIcon.TRASH, danger = true) { handleDelete(asset) })
                                        }
                                    )
                                }
                            }
                        }
                    }
                }
                }

            modelWindowWeapon?.let { weapon ->
                ModelLibraryDialog(modelLibrary(), weapon) { modelWindowWeapon = null }
            }

            assets.firstOrNull { it.id == openedAssetId }?.let { asset ->
                // Animations get room for the timeline; the workspace button opens the full screen.
                AssetDrawer(
                    title = asset.displayTitle,
                    onClose = { openedAssetId = null },
                    widthPx = if (asset.assetType == AssetType.ANIMATION) 1240 else 640,
                    onRename = { name ->
                        val renamed = try {
                            RobloxCraftApiClient.renameAsset(asset.id, name)
                        } catch (t: Throwable) {
                            throw IllegalStateException(FriendlyErrors.describe(t.message, Txt), t)
                        }
                        assets.updateFirst({ it.id == renamed.id }) {
                            cacheUpsert(renamed)
                            renamed
                        }
                    }
                ) {
                    AssetPanel(
                        asset = asset,
                        showTechnicalDetails = !UiModeController.simpleMode,
                        onSync = { handleSync(it) },
                        onFullscreenRequest = { target ->
                            assetForFullscreen = target
                            showFullscreenCode = true
                        },
                        onRefactor = { target, instruction -> openChat(target, instruction) },
                        onOpenChat = { target -> openChat(target, null) },
                        onRestoreRevision = { target, number -> restoreRevision(target, number) },
                        onCancel = { handleCancel(it) },
                        onDelete = { handleDelete(it) },
                        onRegenerate = { handleRegenerate(it) },
                        onEditPrompt = { target -> handleGenerateSimilar(target.prompt, target.assetType, target.metadata["providerId"]) },
                        onReport = { target -> reportTarget = target },
                        meshTools = meshTools
                    )
                }
            }

            WelcomeTour()

            SessionTokenModal(
                visible = showTokenModal,
                onCloseRequest = { showTokenModal = false },
                initialToken = sessionToken,
                onTokenSaved = { newToken, success, sessionSync ->
                    saveSessionToken(newToken)
                    sessionToken = newToken
                    connected = success
                    if (sessionSync != null) {
                        for (asset in sessionSync.activeAssets) {
                            if (assets.none { it.id == asset.id }) {
                                assets.add(0, asset)
                            }
                            cacheUpsert(asset)
                        }
                    }
                    showTokenModal = false
                }
            )

            SyncConfirmationModal(
                visible = showSyncConfirm,
                asset = pendingSyncAsset,
                onCloseRequest = {
                    showSyncConfirm = false
                    pendingSyncAsset = null
                },
                onConfirmSync = { asset ->
                    scope.launch {
                        try {
                            assets.updateFirst({ it.id == asset.id }) { old ->
                                val u = old.copy(
                                    metadata = old.metadata + mapOf(
                                        "uiSyncStatus" to "PENDING",
                                        "uiSyncTimeMs" to Date.now().toString()
                                    )
                                )
                                cacheUpsert(u)
                                u
                            }
                            RobloxCraftApiClient.markAssetForSync(sessionToken, asset.id)
                            RobloxCraftApiClient.syncRoblox(sessionToken)
                            ToastManager.success(Txt.home.queuedForStudio(asset.id.take(6)))
                        } catch (_: Throwable) {
                            ToastManager.error(Txt.home.syncBackendUnavailable)
                        }
                    }
                }
            )

            FullscreenCodeDiffModal(
                visible = showFullscreenCode,
                asset = assetForFullscreen,
                onCloseRequest = {
                    showFullscreenCode = false
                    assetForFullscreen = null
                },
                onRestoreRevision = { rev ->
                    val targetId = assetForFullscreen?.id ?: return@FullscreenCodeDiffModal
                    assets.updateFirst({ it.id == targetId }) { old ->
                        val u = old.copy(
                            luauCode = rev.luauCode ?: old.luauCode,
                            prompt = rev.prompt.takeIf { it.isNotBlank() } ?: old.prompt
                        )
                        cacheUpsert(u)
                        u
                    }
                    showFullscreenCode = false
                    assetForFullscreen = null
                }
            )

            UserSettingsModal(
                visible = showSettingsModal,
                onCloseRequest = { showSettingsModal = false },
                sessionToken = sessionToken,
                onSessionTokenChanged = { newToken -> sessionToken = newToken },
                connected = connected,
                onSettingsSaved = { updated ->
                    activeProviders = updated
                    ToastManager.success(Txt.home.settingsSaved)
                }
            )

            ReportAssetDialog(
                visible = reportTarget != null,
                sending = reportSending,
                onDismiss = { reportTarget = null },
                onSubmit = { reason, comment ->
                    val target = reportTarget ?: return@ReportAssetDialog
                    reportSending = true
                    scope.launch {
                        val ok = RobloxCraftApiClient.reportAsset(target.id, reason, comment)
                        reportSending = false
                        if (ok) {
                            reportTarget = null
                            ToastManager.success(Txt.report.thanks)
                        } else {
                            ToastManager.error(Txt.report.failed)
                        }
                    }
                }
            )

            val currentChat = chatAsset
            if (currentChat != null) {
                AssetChatDrawer(
                    visible = showChatDrawer,
                    asset = currentChat,
                    messages = chatMessages,
                    isLoading = isChatLoading,
                    onCloseRequest = {
                        showChatDrawer = false
                        chatAsset = null
                    },
                    onSendMessage = { instruction ->
                        scope.launch {
                            isChatLoading = true
                            try {
                                val resp = RobloxCraftApiClient.refactorAsset(
                                    assetId = currentChat.id,
                                    instruction = instruction
                                )
                                chatMessages = chatMessages + resp.chatMessage
                            } catch (t: Throwable) {
                                ToastManager.error(Txt.home.refactorFailed(FriendlyErrors.describe(t.message, Txt)))
                            } finally {
                                isChatLoading = false
                            }
                        }
                    },
                    onApplyMessage = { msgId ->
                        scope.launch {
                            try {
                                val updated = RobloxCraftApiClient.applyRefactoredMessage(currentChat.id, msgId)
                                assets.updateFirst({ it.id == updated.id }) {
                                    cacheUpsert(updated)
                                    updated
                                }
                                chatAsset = updated
                                chatMessages = RobloxCraftApiClient.getChatHistory(updated.id)
                                ToastManager.success(Txt.home.changesApplied)
                            } catch (t: Throwable) {
                                ToastManager.error(Txt.home.applyChangesFailed(FriendlyErrors.describe(t.message, Txt)))
                            }
                        }
                    }
                )
            }

            Box(Modifier.height(14.cssRem))
            ToastContainer()

            GenerationQueuePanel()
        }

        SiteFooter()
    }

    val canSave = savePresetTitle.trim().length in 3..60
    ModalDialog(
        visible = showSavePresetModal,
        onCloseRequest = { if (!savePresetLoading) showSavePresetModal = false },
        title = Txt.presetDialog.title,
        footer = ModalDialogConfirmActions(
            confirmText = Txt.common.save,
            cancelText = Txt.common.cancel,
            confirmVariant = AppButtonVariant.PRIMARY,
            onConfirm = {
                scope.launch { submitSavePreset() }
            },
            onCancel = { showSavePresetModal = false },
            confirmLoading = savePresetLoading,
            confirmEnabled = canSave && !savePresetLoading
        )
    ) {
        Column(Modifier.fillMaxWidth().gap(0.75.cssRem)) {
            AppInput(
                value = savePresetTitle,
                onValueChanged = { savePresetTitle = it.take(60) },
                label = Txt.presetDialog.nameLabel,
                placeholder = Txt.presetDialog.namePlaceholder,
                helperText = if (savePresetTitle.isBlank() || savePresetTitle.length < 3) Txt.presetDialog.nameTooShort else Txt.presetDialog.nameCounter(savePresetTitle.length),
                modifier = Modifier.fillMaxWidth()
            )
            AppInput(
                value = savePresetDesc,
                onValueChanged = { savePresetDesc = it.take(140) },
                label = Txt.presetDialog.descriptionLabel,
                placeholder = Txt.presetDialog.descriptionPlaceholder,
                helperText = "${savePresetDesc.length}/140",
                modifier = Modifier.fillMaxWidth()
            )
            AppInput(
                value = savePresetTagsRaw,
                onValueChanged = { savePresetTagsRaw = it.take(80) },
                label = Txt.presetDialog.tagsLabel,
                placeholder = Txt.presetDialog.tagsPlaceholder,
                helperText = Txt.presetDialog.tagsCounter(savePresetTagsRaw.split(',').map { tag -> tag.trim() }.filter { tag -> tag.isNotBlank() }.size) + "/6",
                modifier = Modifier.fillMaxWidth()
            )
            AppCard(Modifier.fillMaxWidth()) {
                Column(Modifier.padding(0.75.cssRem).gap(0.25.cssRem)) {
                    SpanText(
                        Txt.presetDialog.currentPrompt,
                        Modifier.fontSize(0.72.cssRem).fontWeight(FontWeight.SemiBold).color(theme.colors.textSecondary)
                    )
                    SpanText(
                        currentPromptValue.ifBlank { Txt.presetDialog.emptyPrompt },
                        Modifier
                            .fontSize(0.78.cssRem)
                            .color(theme.colors.textPrimary)
                            .fontFamily("ui-monospace", "SFMono-Regular", "Menlo", "monospace")
                            .maxWidth(100.percent)
                    )
                    SpanText(
                        Txt.presetDialog.typeAndLimit(Txt.assetTypes.name(currentTypeValue)),
                        Modifier.fontSize(0.7.cssRem).color(theme.colors.accent)
                    )
                }
            }
        }
    }
}

private fun com.varabyte.kobweb.compose.ui.Modifier.align(
    horizontal: Alignment.Horizontal,
    vertical: Alignment.Vertical
) = this.display(DisplayStyle.Flex)
    .then(if (horizontal == Alignment.CenterHorizontally) justifyContent(JustifyContent.Center) else Modifier)
    .then(if (vertical == Alignment.CenterVertically) alignItems(AlignItems.Center) else Modifier)
